import { Component, Input } from '@angular/core';

import { Lecture } from '../../lectures/shared/lecture';
import { Lesson } from '../shared/lesson';

@Component({
  selector: 'app-lesson-list-item',
  templateUrl: './lesson-list-item.component.html',
  styleUrls: ['./lesson-list-item.component.scss']
})
export class LessonListItemComponent {
  @Input() lesson: Lesson;
  @Input() lecture: Lecture;
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lessons/lesson-list-item/lesson-list-item.component.ts